<div class="primary-bg header min-height">
  <h2>{{denominazione}}</h2>
  <p class="small light">{{'Codice pratica: ' + praticaCode}}</p>
</div>
